import React, { useState, useEffect, useRef, useContext } from "react";
import { useOutletContext } from "react-router-dom";
import "./SupplierDetails.css";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import SearchField from "../SearchField/SearchField";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { gsap } from "gsap";
import SocketContext from "../../contexts/SocketContext";

const SupplierDetails = () => {
  // General States
  const axiosPrivate = useAxiosPrivate(null);
  const navigate = useNavigate();
  const location = useLocation();

  // Socket
  const { socket } = useContext(SocketContext);

  //Refs
  const USMRef = useRef(null);

  // Import Outlet Context Properties
  const [
    showSupDetails,
    selectedSupplier,
    setSelectedSupplier,
    setReloaddata,
    reloaddata,
    setShowsuccess,
    setSuccessMSG,
  ] = useOutletContext();

  // Supplier Edits
  const [supplierEdits, setSupplierEdits] = useState(selectedSupplier ? selectedSupplier : {});
  const [editingSupplier, setEditingSupplier] = useState(false);
  const [deletecheck, setDeletecheck] = useState();

  // Handle Input Change
  const handleInputChange = (e) => {
    setEditingSupplier(true);
    setSupplierEdits({ ...supplierEdits, [e.target.name]: e.target.value });
  };

  // Handle Country Select
  const handleCountrySelect = (item) => {
    setSupplierEdits({ ...supplierEdits, ["country"]: item.country, ["countryID"]: item.countryID });
    setEditingSupplier(true);
  };
  // Handle Port Select
  const handlePortSelect = (item) => {
    setSupplierEdits({ ...supplierEdits, ["portOfLoad"]: item.portOfLoad, ["POLID"]: item.POLID });
    setEditingSupplier(true);
  };

  // Cleanup
  const [toggleClearSF, setToggleClearSF] = useState(false);

  // Set selected supplier on change of selected supplier
  useEffect(() => {
    setSupplierEdits(selectedSupplier);
    setEditingSupplier(false);
    setToggleClearSF(!toggleClearSF);
  }, [selectedSupplier]);

  // Save supplier edits
  const saveSupplierEdits = async () => {
    try {
      const response = await axiosPrivate.post("api/suppliers/updatesupplier", {
        supplierEdits,
      });
      if (response.data.msg === "Saved") {
        setReloaddata(!reloaddata);
        setShowsuccess((prev) => !prev);
        setSuccessMSG("Edits saved successfully.");
        setEditingSupplier(false);
        await socket.emit("updatesupplier", supplierEdits);
      }
    } catch (err) {
      navigate("/login", { state: { from: location }, replace: true });
    }
  };

  // Delete Supplier
  const deleteSupplier = async (supID) => {
    const response = await axiosPrivate.post("api/suppliers/deletesupplier", { supID });
    if (response.data.msg === "Deleted") {
      setDeletecheck("");
      setReloaddata(!reloaddata);
      setSelectedSupplier("");
      await socket.emit("deletesupplier", selectedSupplier.supplierID);
    }
    if (response.data.msg === "Not Found") {
      setDeletecheck("");
      setReloaddata(!reloaddata);
      setSelectedSupplier("");
    }
  };

  return (
    <div className='supDetails'>
      {showSupDetails && (
        <>
          <h1>{selectedSupplier.companyCode}</h1>
          <h2>Edit Supplier:</h2>
          <form
            className='editsupplier'
            onSubmit={(e) => {
              e.preventDefault();
              saveSupplierEdits();
            }}
          >
            <div className='form-item'>
              <label>Supplier ID:</label>
              <input readOnly style={{ background: "var(--gray)" }} value={supplierEdits?.supplierID} />
            </div>
            <div className='form-item'>
              <label>Company Code:</label>
              <input
                required
                name='companyCode'
                autoComplete='off'
                onChange={(e) => handleInputChange(e)}
                value={supplierEdits?.companyCode}
              />
            </div>
            <div className='form-item'>
              <label>Company Name:</label>
              <input
                required
                name='companyName'
                autoComplete='off'
                onChange={(e) => handleInputChange(e)}
                value={supplierEdits?.companyName}
              />
            </div>
            <div className='form-item'>
              <label>Address:</label>
              <textarea
                required
                name='streetAddress'
                autoComplete='off'
                onChange={(e) => handleInputChange(e)}
                value={supplierEdits?.streetAddress}
              />
            </div>
            <div className='form-item'>
              <label>City:</label>
              <input
                required
                name='city'
                autoComplete='off'
                onChange={(e) => handleInputChange(e)}
                value={supplierEdits?.city}
              />
            </div>
            <div className='form-item'>
              <label>Country:</label>
              <SearchField
                required={true}
                searchURL='api/countries/getcountries'
                value={supplierEdits.country}
                valueName='country'
                valueID='countryID'
                style={{ width: "95%" }}
                onItemSelect={handleCountrySelect}
                clearfield={toggleClearSF}
              />
            </div>
            <div className='form-item'>
              <label>Default POD:</label>
              <SearchField
                required={true}
                searchURL='api/ports/getallloadports'
                value={supplierEdits.portOfLoad}
                valueName='portOfLoad'
                valueID='POLID'
                style={{ width: "95%" }}
                onItemSelect={handlePortSelect}
                clearfield={toggleClearSF}
              />
            </div>
            <div className='form-item'>
              <label>Website:</label>
              <input
                required
                name='website'
                autoComplete='none'
                onChange={(e) => handleInputChange(e)}
                value={supplierEdits?.website}
              />
            </div>
            <div className='form-item'>
              <label>Notes:</label>
              <textarea
                name='notes'
                autoComplete='none'
                onChange={(e) => handleInputChange(e)}
                value={supplierEdits?.notes}
              />
            </div>
            <div className='form-buttons'>
              <button
                type='button'
                onClick={(e) => {
                  navigate("/admin/suppliers", { state: { from: location }, replace: true });
                  setSelectedSupplier({});
                  setToggleClearSF(!toggleClearSF);
                }}
              >
                Cancel
              </button>
              <button
                type='submit'
                className={editingSupplier ? "mainbutton" : "disabledbutton"}
                disabled={!editingSupplier}
              >
                Save Edits
              </button>
            </div>
          </form>

          <h2>Delete Supplier:</h2>
          <p>
            Type <b>{selectedSupplier.companyCode}: </b>
            <input
              autoComplete='off'
              name='deletecheck'
              value={deletecheck}
              style={{ marginRight: "1rem" }}
              onChange={(e) => {
                setDeletecheck(e.target.value);
              }}
            />
            {deletecheck == selectedSupplier.companyCode ? (
              <button onClick={(e) => deleteSupplier(selectedSupplier.supplierID)} style={{ margin: 0 }}>
                Delete
              </button>
            ) : (
              ""
            )}
          </p>
        </>
      )}
    </div>
  );
};

export default SupplierDetails;
